import { LegalPage } from "./LegalPage";

export function TermsPage() {
  return <LegalPage kind="terms" fallbackTitle="Terms of Use" />;
}
